module.exports = __webpack_public_path__ + "img/group_y.a6a7e52a.svg";